import { supabaseClient } from "@/lib/supabase";
import type { StudyRow } from "../types";

export const studiesQueryKey = "studies";

const studySelect = `
    *,
    study_labels(label_id, diary_labels(label_id, label_name)),
    study_forms(form_id, forms(form_id, form_name)),
    study_templates(template_id, templates(template_id, quickstart_key, settings)),
    study_invites(study_invite_id, status)
`;

export async function selectStudies(): Promise<StudyRow[]> {
    const { data, error } = await supabaseClient.from("studies").select(studySelect).order("updated_at", {
        ascending: false,
    });

    if (error) {
        throw error;
    }

    return (data ?? []) as StudyRow[];
}

export const studiesQueryOptions = (userId: string, isAdmin: boolean) => ({
    queryKey: [studiesQueryKey, userId, isAdmin],
    queryFn: selectStudies,
    staleTime: 1000 * 60 * 5,
});

export async function selectStudyById(studyId: string): Promise<StudyRow | null> {
    const { data, error } = await supabaseClient
        .from("studies")
        .select(studySelect)
        .eq("study_id", studyId)
        .maybeSingle();

    if (error) {
        throw error;
    }

    return (data as StudyRow | null) ?? null;
}

export const studyByIdQueryOptions = (studyId: string) => ({
    queryKey: [studiesQueryKey, "detail", studyId],
    queryFn: () => selectStudyById(studyId),
});
